class MobileNavigation {
    static states = {
        OPEN: 'open',
        CLOSED: 'closed',
    };

    static state = MobileNavigation.states.CLOSED;

    static toggles = document.querySelectorAll(
        '[data-mobile-navigation-toggle]'
    );

    static sidebar = document.querySelector('[data-mobile-navigation-sidebar]');

    static overlay = document.querySelector('[data-mobile-navigation-overlay]');

    static content = document.querySelector('[data-mobile-navigation-content]');

    static init = () => {
        Array.from(MobileNavigation.toggles).forEach((toggle) => {
            toggle.addEventListener('click', () => {
                if (MobileNavigation.state === MobileNavigation.states.CLOSED) {
                    MobileNavigation.open();
                } else {
                    MobileNavigation.close();
                }
            });
        });
    };

    static open = () => {
        const { sidebar } = MobileNavigation;

        sidebar.classList.add('is-active');

        MobileNavigation.state = MobileNavigation.states.OPEN;
    };

    static close = () => {
        const { sidebar } = MobileNavigation;

        sidebar.classList.remove('is-active');

        MobileNavigation.state = MobileNavigation.states.CLOSED;
    };
}

(() => {
    MobileNavigation.init();
})();
